/**
 * Todo / Calendar API サービス
 *
 * フルアクセス権限を持つユーザーのみ使用可能
 */

import { apiClient } from '@/api/client'
import type {
  AutoScheduleRequest,
  AutoScheduleResponse,
  CalendarEvent,
  FreeSlotsResponse,
  ManualScheduleRequest,
  TodoCreate,
  TodoResponse,
  TodoSource,
  TodoUpdate,
} from '@/api/types/todo'

// ============ Todo CRUD ============
export const listTodos = async (params: {
  status?: string
  include_done?: boolean
  completed_from?: string
  completed_to?: string
  /** カンマ区切りの id。指定時は状態に関係なくこの id だけ返す */
  ids?: string
  source?: TodoSource
  /** library_book なら ISBN */
  source_ref?: string
  limit?: number
}): Promise<TodoResponse[]> => {
  const res = await apiClient.get('/todos', { params })
  return res.data
}

/** Todo に付いているプロジェクト名の一覧（完了・却下済みの Todo も含む） */
export const listTodoProjects = async (): Promise<string[]> => {
  const res = await apiClient.get('/todos/projects')
  return res.data
}

export const getTodo = async (id: number): Promise<TodoResponse> => {
  const res = await apiClient.get(`/todos/${id}`)
  return res.data
}

export const createTodo = async (body: TodoCreate): Promise<TodoResponse> => {
  const res = await apiClient.post('/todos', body)
  return res.data
}

export const updateTodo = async (id: number, body: TodoUpdate): Promise<TodoResponse> => {
  const res = await apiClient.patch(`/todos/${id}`, body)
  return res.data
}

export const deleteTodo = async (id: number): Promise<void> => {
  await apiClient.delete(`/todos/${id}`)
}

// ============ Calendar (Phase 2) ============
export const getCalendarEvents = async (from: string, to: string): Promise<CalendarEvent[]> => {
  const res = await apiClient.get('/calendar/events', { params: { from, to } })
  return res.data
}

export const getFreeSlots = async (from: string, to: string): Promise<FreeSlotsResponse> => {
  const res = await apiClient.get('/calendar/free-slots', { params: { from, to } })
  return res.data
}

export const autoSchedule = async (body: AutoScheduleRequest): Promise<AutoScheduleResponse> => {
  const res = await apiClient.post('/todos/auto-schedule', body)
  return res.data
}

export const manualSchedule = async (todoId: number, body: ManualScheduleRequest): Promise<TodoResponse> => {
  const res = await apiClient.post(`/todos/${todoId}/schedule`, body)
  return res.data
}

export const clearSchedule = async (todoId: number): Promise<TodoResponse> => {
  const res = await apiClient.delete(`/todos/${todoId}/schedule`)
  return res.data
}
